import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { Users } from "@/icons";
import { useTranslate } from "@/providers/context";
import { getUrlFromFilename, slugify } from "@/utils";

import { CommunityGroupWithDetails } from "../../types";
import { isAutoJoinGroup } from "../../util";

export const CommunityGroupCard = ({
  group,
}: {
  group: CommunityGroupWithDetails;
}) => {
  const { translate } = useTranslate();
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    navigate(`/community/${slugify(group.Name)}`);
  }, [group.Name, navigate]);

  const thumbnailUrl = group.ThumbnailURL
    ? getUrlFromFilename(group.ThumbnailURL)
    : undefined;

  return (
    <div className="flex flex-col">
      <div
        className="mb-3 aspect-video w-full cursor-pointer overflow-hidden rounded-lg bg-surface-thumbnail transition-opacity duration-100 hover:opacity-85"
        onClick={handleClick}
      >
        {thumbnailUrl && (
          <img
            src={thumbnailUrl}
            alt={group.Name}
            className="h-full w-full object-cover"
          />
        )}
      </div>
      <div
        className="p2-bold ellipsis mb-2 cursor-pointer hover:text-item-secondary"
        onClick={handleClick}
      >
        {group.Name}
      </div>
      <div className="p2-medium flex items-center gap-1 text-item-secondary">
        <Users width={20} height={20} />
        {isAutoJoinGroup(group)
          ? translate("All Members")
          : `${group.membersCount} ${translate("Members")}`}
      </div>
    </div>
  );
};
